import { resetRequest } from '@jetshop/core/data/mutations/accountMutations.gql';
import t from '@jetshop/intl';
import { Form, Formik } from 'formik';
import React from 'react';
import { useMutation } from '@apollo/react-hooks';
function validate(values) {
    let errors = {};
    if (!values.email) {
        errors['email'] = t('This field is required');
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors['email'] = t('Invalid email address');
    }
    return errors;
}
function handleMutationError(actions) {
    actions.setStatus({
        globalError: t('Something went wrong. Please check your input, or try again later.'),
    });
    actions.setSubmitting(false);
}
export function ForgotPasswordProvider(props) {
    const [mutate] = useMutation(resetRequest);
    return (React.createElement(Formik, { initialValues: { email: '' }, validate: validate, onSubmit: (values, actions) => {
            actions.setSubmitting(true);
            mutate({ variables: { email: values.email } })
                .then((resp) => {
                if (resp.data.requestPasswordReset.success) {
                    actions.setStatus({ success: true });
                    actions.setSubmitting(false);
                }
                else {
                    handleMutationError(actions);
                }
            })
                .catch(() => {
                handleMutationError(actions);
            });
        } }, (formik) => (React.createElement(Form, null,
        React.createElement(ForgotPasswordContext.Provider, Object.assign({ value: { formik } }, props))))));
}
export const ForgotPasswordContext = React.createContext(undefined);
export function useForgotPasswordData() {
    var _a, _b;
    const { formik } = React.useContext(ForgotPasswordContext);
    const submitted = (_a = formik === null || formik === void 0 ? void 0 : formik.status) === null || _a === void 0 ? void 0 : _a.success;
    const globalError = (_b = formik === null || formik === void 0 ? void 0 : formik.status) === null || _b === void 0 ? void 0 : _b.globalError;
    const emailInputProps = {
        type: 'email',
        name: 'email',
        required: true,
    };
    return Object.assign({ submitted,
        globalError,
        emailInputProps }, formik);
}
//# sourceMappingURL=ForgotPasswordProvider.js.map